import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useDeleteCompanyDocument = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`company-documents/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-documents'] });
    },
  });

  const deleteCompanyDocument = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    deleteCompanyDocument,
    error,
    isLoading,
    reset,
  };
};
